import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IContactCentreModel } from "src/types/models/apiModels";

export class ContactCentreListViewModel {
  private apiService: ApiService;

  constructor(accessToken: string) {
    this.apiService = new ApiService({ accessToken: accessToken });
  }

  async deleteContactCentre(contactCentreId: string): Promise<{ result?: boolean; error?: string }> {
    const URL = `/onboard/contact-centre/${contactCentreId}`

    const result = await this.apiService.deleteAsync<IApiResponse<boolean>, undefined>(URL);

    if (result.scResponse.code !== 2000) {
      return {
        result: false,
        error: result.scResponse.message,
      };
    }

    return {
      result: result.scResponse.data,
    };
  }

  async fetchContactCenters(): Promise<IContactCentreModel[]> {
    const response = await this.apiService.getAsync<any>(
      "/onboard/contact-centres"
    );

    if (response?.scResponse?.code === 2000) {
      return response.scResponse.data.sort((a: IContactCentreModel, b: IContactCentreModel) => {
        return a.contactCentreCode.localeCompare(b.contactCentreCode);
      });
    }

    return [];
  }
}
